module.exports = "/_next/static/resources/photo-4-0f619d95f448e06559ced5e657dbf45a.webp";